import { useState, useEffect, useCallback } from 'react';

// Same floating-popup-with-auto-dismiss pattern as PG's ViewLogbooks.js
// (its `success`/`error` state + 1.5s setTimeout-clear useEffect), just
// collapsed into one hook so every UG review screen doesn't re-implement
// the two state vars + two timers by hand.
const useToast = () => {
  const [toast, setToast] = useState(null); // { type: 'success' | 'error', message }

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(null), 1500);
    return () => clearTimeout(timer);
  }, [toast]);

  const showSuccess = useCallback((message) => setToast({ type: 'success', message }), []);
  const showError = useCallback((message) => setToast({ type: 'error', message }), []);

  return { toast, showSuccess, showError };
};

export default useToast;
